export const quanta = () => (
  <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M1.70711 12.8478 12.2929 2.26204c.3905-.39053 1.0237-.39053 1.4142 0L24.2929 12.8478c.3905.3905.3905 1.0237 0 1.4142L13.7071 24.8478c-.3905.3905-1.0237.3905-1.4142 0L1.70711 14.262c-.39053-.3905-.39053-1.0237 0-1.4142Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="m9.38679 12.8479 2.90581-2.90581c.3905-.39052 1.0237-.39052 1.4142 0l2.9058 2.90581c.3905.3905.3905 1.0237 0 1.4142l-2.9058 2.9058c-.3905.3905-1.0237.3905-1.4142 0l-2.90581-2.9058c-.39052-.3905-.39052-1.0237 0-1.4142Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
